<template>
    <div class="tournaments">
        <p class="title">全国赛事数据</p>
        <el-date-picker v-model="rangePickerTime" size="large" class="timeBox" type="daterange" align="right" format="yyyy-MM-dd" value-format="yyyy-MM-dd" start-placeholder="筛选开始时间" end-placeholder="筛选结束日期" @change="changeTime"></el-date-picker>
        <div class="clear flex">
            <div class="mapBox">
                <div id="echarts" class="fl" :style="`width: 60vw; height: 60vw;`"></div>
                <div class="legend">
                    <div class="bgNameItem clear">
                        <span class="name fl" v-for="(item, index) in legendName" :key="'legendName' + index">{{item}}</span>
                    </div>
                    <div class="bgColorItem clear">
                        <span class="bg fl" v-for="(item, index) in legendColor" :key="'legendcolor' + index" :style="`background-color: ${item}`"></span>
                    </div>
                </div>
            </div>
            <div class="fl table">
                <el-table :data="ysData" border style="width: 100%">
                    <el-table-column prop="name" label="地域" align="center"></el-table-column>
                    <el-table-column prop="count" label="活动总数" align="center"></el-table-column>
                    <el-table-column prop="total" label="预计线下人数" align="center"></el-table-column>
                </el-table>
            </div>
        </div>
    </div>
</template>

<script>
import * as echarts from 'echarts'
import 'echarts/map/js/china'
import { cityData } from '../../city.js'
import bigData from '@/services/bigData'
export default {
    data() {
        return {
            myChart: '',
            activityData: [],
            ysData: [],
            legendName: ['0', '1场', '5场', '10场', '15场', ''],
            legendColor: ['#424269', '#53538A', '#6464BB', '#7A7AFF', '#79C3FF'],
            rangePickerTime: '',
            option: {
                tooltip: {
                    triggerOn: "mousemove",
                    formatter:function(params){
                        return `<div style="width: 90px;height: 35px;text-align: center;padding: 12px 12px;font-size: 12px;line-height: 17px"><p>${params.name}</p><p style="margin: 4px 0">${params.value}场赛事</p></div>`;
                    },
                    backgroundColor:'rgba(29, 38, 71)',
                    extraCssText:'box-shadow:0 0 4px rgba(11, 19, 43,0.8);' // 额外附加的阴影
                },
                visualMap: {
                    min: 0,
                    max: 1000,
                    left: 26,
                    bottom: 40,
                    showLabel: !0,
                    text: ["高", "低"],
                    pieces: [{
                        gt: 15,
                        label: "> 16 人",
                        color: "#79C3FF"
                    }, {
                        gte: 9,
                        lte: 16,
                        label: "10 - 15 人",
                        color: "#7A7AFF"
                    }, {
                        gte: 4,
                        lt: 11,
                        label: "5 - 10 人",
                        color: "#6464BB"
                    }, {
                        gt: 0,
                        lt: 6,
                        label: "1 - 5 人",
                        color: "#53538A"
                    }, {
                        value: 0,
                        color: "#424269"
                    }],
                    show: false
                },
                geo: {
                    map: "china",
                    roam: !1,
                    scaleLimit: {
                        min: 1,
                        max: 2
                    },
                    zoom: 1,
                    label: {
                        show:false
                    },
                    emphasis:{
                        label:{
                            show:false
                        }
                    },
                    itemStyle: {
                        normal: {
                            shadowBlur: 1,
                            shadowColor: 'rgba(18, 32, 70,0.4)',
                            borderColor: "rgba(18, 32, 70)"
                        },
                        emphasis: {
                            areaColor: "rgba(23, 240, 204)",
                            shadowOffsetX: 0,
                            shadowOffsetY: 0,
                            borderWidth: 0
                        }
                    }
                },
                series: [{
                    name: "地域分布",
                    type: "map",
                    geoIndex: 0,
                    data: []
                }]
            }
        }
    },
    created() {
        this.timeForMat()
        this.getTableData()
    },
    methods: {
        async getList() {
            let data = {
                startDay: this.rangePickerTime[0],
                endDay: this.rangePickerTime[1]
            }
            const res = await bigData.activity(data)
            this.hanleData(res.result.data)
        },
        getTableData() {
            let data = {
                startDay: this.rangePickerTime[0],
                endDay: this.rangePickerTime[1],
                pageSize: 34,
                pageNumber: 1
            }
            bigData.areaActivity(data).then(res => {
                this.ysData = res.result.data
            })
        },
        getCityDetails(id) {
            let data = {
                startDay: this.rangePickerTime[0],
                endDay: this.rangePickerTime[1],
                provinceId: id
            }
            bigData.areaCityActivity(data).then(res => {
                this.ysData = res.result.data
            })
        },
        hanleData(res) {
            let data = cityData;
            data.map(v => {
                v.value = 0
                res.map(vv => {
                    if(v.id == vv.provinceId) v.value = vv.total * 1
                })
            })
            this.activityData = data
            this.option.series[0].data = data;
            this.set()
        },
        set(){
            this.myChart = echarts.init(document.getElementById('echarts'));
            this.myChart.clear();//如果图表有修改需求建议加上此方法先清后画
            this.myChart.setOption(this.option);
            this.myChart.getZr().on('click', (params) => {
                !params.target && this.getTableData()
            })
            this.myChart.on('click', (params) => {
                this.getCityDetails(params.data.id)
            })               
        },
        changeTime() {
            this.getList()
            this.getTableData()
        },
        timeForMat () {
            // 拼接时间
            let time1 = new Date()
            time1.setTime(time1.getTime() - (24 * 60 * 60 * 1000))
            let Y1 = time1.getFullYear()
            let M1 = ((time1.getMonth() + 1) > 10 ? (time1.getMonth() + 1) : '0' + (time1.getMonth() + 1))
            let D1 = (time1.getDate() > 10 ? time1.getDate() : '0' + time1.getDate())
            let timer1 = Y1 + '-' + M1 + '-' + D1 // 当前时间
            let time2 = new Date()
            time2.setTime(time2.getTime() - (24 * 60 * 60 * 1000 * 7))
            let Y2 = time2.getFullYear()
            let M2 = ((time2.getMonth() + 1) > 10 ? (time2.getMonth() + 1) : '0' + (time2.getMonth() + 1))
            let D2 = (time2.getDate() > 10 ? time2.getDate() : '0' + time2.getDate())
            let timer2 = Y2 + '-' + M2 + '-' + D2 // 之前的7天或者30天
            this.rangePickerTime = [timer2, timer1 ]
            this.getList()
            this.getTableData()
        }
    }
}
</script>

<style lang="scss" scoped>
.tournaments{
    .title{
        color: #fff;
        font-size: 16px;
        line-height: 22px;
        margin-bottom: 13px;
    }
    #echarts{
        background-color: #323250;
        border-radius: 12px 0 0 12px
    }
}
.mapBox{
    position: relative;
    .legend{
        position: absolute;
        width: 260px;
        left: 24px;
        bottom: 24px;
    }
    .bgNameItem{
        margin-bottom: 13px;
    }
    .bgNameItem .name{
        color: #767695;
        font-size: 12px;
        width: 51px;
        text-align: left;
    }
    .bgColorItem .bg{
        width: 51px;
        height: 13px;
    }
}
.timeBox{
    margin-bottom: 13px;
}
::v-deep .el-input__inner{
    background-color: #151522;
    border: none;
    border-radius: 12px;
}
::v-deep .el-range-input{
    background-color: #151522;
    color: #9494CC;
}
::v-deep thead{
    color: #A1A1CC
}
.flex{
    display: flex;
    .table{
        flex: 1;
        background-color: #292941
    }
    ::v-deep .el-table{
        background-color: #292941;
        width: 100%;
    }
    ::v-deep .el-table tr{
        background-color: transparent !important;
        border: none !important;
        
    }
    ::v-deep .el-table th{
        background-color: transparent !important;
        border: none !important;
    }
    ::v-deep .el-table td{
        border: none !important;
        color: #fff;
        border-bottom: 1px solid #2F2F48 !important
    }
    ::v-deep .el-table tbody tr:hover>td {
        background-color: #222236 !important
    }
    .el-table::before{
        height: 0;
    }
    .el-table--border::after{
        width: 0;
    }
    .el-table--border, .el-table--group{
        border: none !important
    }
}
::v-deep .el-date-editor .el-range__icon{
    color: #9494CC
}
</style>
